import { useState, useEffect, useRef } from "react"
import { useHistory } from "react-router-dom"
import { OverviewUtilizationCard } from "../atoms"
import { DownloadPngButton } from '../../opdClaims/primitives'
import { OverviewSectionIcon, OverviewTrendIcon } from '../../overview/OverviewSectionIcon'
import { handleAppError } from "../../handlers"
import { OverviewApi } from "../../../services"
import { commaingNumber } from "../../../utils"
import { SemiDonughnutGraph } from "../molecules"
import { SpinnerDotted } from "../../common/atoms"

const StepsCard = ({ contractId, startDate, endDate, totalCustomerCount = 0, classes = '' }) => {
  const [state, setState] = useState({ loading: true })
  const history = useHistory()
  const cardRef = useRef(null)

  useEffect(() => {
    if (!contractId) return

    setState(prevState => { return { ...prevState, loading: true } })
    OverviewApi.fetchStepsOverview({ contract_id: contractId, start_date: startDate, end_date: endDate },
      (res) => {
        setState({ ...res.data, loading: false })
      },
      (err) => handleAppError(err)
    )
  }, [contractId])

  const { sponsored = false, average_steps_per_day = 0, average_steps_per_month = 0, employee_sync_count = 0,
    avgerage_steps_increase_percentage = 0, steps_increase_percentage = 0, loading } = state
  const stepsPerIncreased = steps_increase_percentage > 0
  const avgStepsPerIncreased = avgerage_steps_increase_percentage > 0
  const stepsPerIncrease = steps_increase_percentage.toString().replace(/-/g, '')
  const avgStepsPerIncrease = avgerage_steps_increase_percentage.toString().replace(/-/g, '')

  const tileSynced = 'Employees whoe synced steps'
  const tileMonthly = 'Monthly steps taken'
  const tileDaily = 'Average Steps taken per day'

  return (
    <div
      ref={cardRef}
      className={`rounded-[14px] border border-gray-300 bg-white p-6 ${classes}`}
    >
      <div className='pb-4'>
        <div className='flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between'>
          <div className='flex min-w-0 flex-1 gap-3'>
            <OverviewSectionIcon name='steps' className='mt-0.5' />
            <div className='min-w-0'>
              <div className='flex flex-wrap items-center gap-2'>
                <p className='mb-0 max-w-full text-base font-semibold leading-snug text-gray-800'>Steps</p>
                {sponsored && (
                  <span className='inline-flex shrink-0 rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-700'>
                    Sponsored
                  </span>
                )}
                <DownloadPngButton nodeRef={cardRef} fileName='steps' />
              </div>
            </div>
          </div>
          <div className='flex flex-shrink-0' data-download-ignore='true'>
            <button
              type='button'
              className='border-0 bg-transparent p-0 text-xs font-fig-semibold text-blue-700 transition-colors hover:text-blue-800 focus:outline-none'
              onClick={() => '/steps' && history.push('/steps')}
            >
              View insights →
            </button>
          </div>
        </div>
      </div>
      {!loading ? (
        <div className='grid grid-cols-3 gap-6'>
          <div className='flex min-h-0 flex-col'>
            <SemiDonughnutGraph
              tileLabel={tileSynced}
              linerStyles={employee_sync_count?.toString().length > 5 ? 'w-7/12 text-center bottom-6' : 'bottom-11'}
              id='steps-myChart'
              total={totalCustomerCount}
              completed={employee_sync_count}
              title='step utilization'
              liner={
                <span>
                  <span className='text-sm font-semibold'>{employee_sync_count}</span> out of {totalCustomerCount} employees
                </span>
              }
              graphClasses='-mt-8 -mb-4'
              classes='flex-1'
              metricValue='*includes only active employees'
            />
          </div>
          <div className='flex min-h-0 flex-col'>
            <OverviewUtilizationCard
              tileLabel={tileMonthly}
              title={
                <span className='flex flex-row items-baseline gap-1.5 font-jetbrains-mono tabular-nums text-gray-900'>
                  {commaingNumber(parseInt(average_steps_per_month, 10))}
                  <>
                    <OverviewTrendIcon up={stepsPerIncreased} className='mb-0 ml-0.5 mt-0 h-3 w-3' />
                    <span
                      className='font-jetbrains-mono text-sm font-semibold'
                      style={{ color: stepsPerIncreased ? '#14866D' : '#E8432C' }}
                    >
                      {stepsPerIncrease}%
                    </span>
                  </>
                </span>
              }
              liner='Steps / month'
              classes='flex-1'
            />
          </div>
          <div className='flex min-h-0 flex-col'>
            <OverviewUtilizationCard
              tileLabel={tileDaily}
              title={
                <span className='flex flex-row items-baseline gap-1.5 font-jetbrains-mono tabular-nums text-gray-900'>
                  {commaingNumber(parseInt(average_steps_per_day, 10))}
                  <>
                    <OverviewTrendIcon up={avgStepsPerIncreased} className='mb-0 ml-0.5 mt-0 h-3 w-3' />
                    <span
                      className='font-jetbrains-mono text-sm font-semibold'
                      style={{ color: avgStepsPerIncreased ? '#14866D' : '#E8432C' }}
                    >
                      {avgStepsPerIncrease}%
                    </span>
                  </>
                </span>
              }
              liner='Average steps / day'
              classes='flex-1'
            />
          </div>
        </div>
      ) : (
        <div className='flex h-40 items-center justify-center'>
          <SpinnerDotted />
        </div>
      )}
    </div>
  )
}

export default StepsCard